export const UPDATE_AVAILABLE = 'UPDATE_AVAILABLE'

export function updateAvailable() {
  return { type: UPDATE_AVAILABLE, payload: {} }
}
